"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HoverCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const RadixHoverCard = __importStar(require("@radix-ui/react-hover-card"));
const constants_1 = require("../constants");
const OPEN_DELAY = 300;
const Trigger = (0, styled_1.default)(RadixHoverCard.Trigger)({
    cursor: 'default',
});
const Content = (0, styled_1.default)(RadixHoverCard.Content) `
  transform-origin: var(--radix-hover-card-content-transform-origin);

  z-index: ${constants_1.theme.zIndex.hovercard};
  animation: scaleIn 0.1s cubic-bezier(0.168, 0.84, 0.44, 1);

  @keyframes scaleIn {
    from {
      opacity: 0;
      transform: scale(0);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`;
const HoverCard = ({ trigger, children, side, arrow = true, sideOffset = 5, }) => {
    return ((0, jsx_runtime_1.jsxs)(RadixHoverCard.Root, { openDelay: OPEN_DELAY, children: [(0, jsx_runtime_1.jsx)(Trigger, { asChild: true, children: trigger }), (0, jsx_runtime_1.jsx)(RadixHoverCard.Portal, { children: (0, jsx_runtime_1.jsxs)(Content, { sideOffset: sideOffset, side: side, children: [children, arrow && (0, jsx_runtime_1.jsx)(RadixHoverCard.Arrow, {})] }) })] }));
};
exports.HoverCard = HoverCard;
HoverCard.Trigger = Trigger;
HoverCard.Content = Content;
